import React from 'react';
import { Input, Form } from 'antd';

const { TextArea } = Input;

export const CarrierComment = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <div className="offer-card__item">
      <span className="label">Комментарий перевозчика:</span>
      <Form.Item>
        {getFieldDecorator('carrierComment')(<TextArea disabled={disabled} rows={4} cols={50} />)}
      </Form.Item>
    </div>
  );
};
